
/* User defined models */
export class Year {
  name: string;

  constructor(name: number) {
    this.name = name.toString();
  }
}
